import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type BillStateData = {
    customerId: string,
    productIds: string[],
    exchangeProductIds: string[],
    igst: number,
    cgst: number,
    sgst: number,
    discountedAmount: number,
    exchangeAmount: number,
    additionalCharges: number,
    netAmount: number,
    totalAmount: number,
    paymentsInfo: {
        paidAmount: number,
        paymentMode: string,
    }[],
    remainingAmount: number,
    billNumber: string,
    billedById: string,
    createdAt: number,
    updatedAt: number,
    freezedRateId: string,
    isCancelled?: boolean,
    id: string,
}

const initialState: BillStateData[] = []

const billsSlice = createSlice({
    name: 'bills',
    initialState,
    reducers: {
        setBills(state, action: PayloadAction<BillStateData[]>) {
            return action.payload;
        },
        addBill(state, action: PayloadAction<BillStateData>) {
            state.push(action.payload);
            return state;
        },
        editBill(state, action: PayloadAction<BillStateData>) {
            const index = state.findIndex(bill => bill.billNumber === action.payload.billNumber);
            if (index !== -1) {
                state[index] = action.payload;
            }
            return state;
        },
        deleteBill(state, action: PayloadAction<BillStateData>) {
            const index = state.findIndex(bill => bill.billNumber === action.payload.billNumber);
            if (index === -1) {
                return state;
            }
            state.splice(index, 1);
            return state;
        },
        resetBill() {
            return initialState;
        }
    }
})

export const { setBills, addBill, editBill, deleteBill, resetBill } = billsSlice.actions;
export default billsSlice.reducer;